<template>
    <SelectItem
        :class="[element('item'), $attrs.class]"
        :value="value"
        :disabled="disabled || undefined"
        :text-value="textValue"
    >
        <SelectItemText :class="element('item-text')">
            <slot>{{ textValue ?? value }}</slot>
        </SelectItemText>

        <SelectItemIndicator
            :class="element('item-indicator')"
            aria-hidden="true"
        >
            <slot name="item-indicator">
                &#10003;
            </slot>
        </SelectItemIndicator>
    </SelectItem>
</template>

<script setup lang="ts">
import type { KSelectItemProps } from './types'
import useBem from '@yeeroen/use-bem'
import { SelectItem, SelectItemIndicator, SelectItemText } from 'reka-ui'

defineOptions({ name: 'KSelectItem', inheritAttrs: false })

defineProps<KSelectItemProps>()

defineSlots<{
    'default'?: () => unknown
    'item-indicator'?: () => unknown
}>()

// Item classes come from the content block, not from `k-select-item`: the popup is its
// own BEM block, and this thin wrapper exists so slot users never have to know that
// `SelectItemText` — not the slot content — is what registers the option.
// The stylesheet is emitted once by KSelect — the only component these render inside.
const { element } = useBem('k-select-content')
</script>
